import ytplayer from "yt-player";

export default class Modal {
  constructor() {
    this.modal = document.querySelector('.modal');
    if (! this.modal) return;

    // find all modal open buttons
    this.modalTriggers = document.querySelectorAll('[data-youtube-id]');

    if (this.modalTriggers) {
      this.modalTriggers.forEach((element) => {
        element.addEventListener('click', this.triggerHandler.bind(this));
      });
    }

    // We stop/remove the player with the this.modal eventlistener
    // this.modalCloseTriggers = document.querySelectorAll('.modal__close');
    // if (this.modalCloseTriggers) {
    //   this.modalCloseTriggers.forEach((element) => {
    //     element.addEventListener('click', this.toggleModal.bind(this));
    //   });
    // }

    this.player = new ytplayer('.modal__video', {
      modestBranding: true,
      related: false,
      info: false,
    });

    this.modal.addEventListener('click', this.toggleModal.bind(this));
  }

  triggerHandler(event) {
    const youtubeId = event.currentTarget.getAttribute('data-youtube-id');
    const title = event.currentTarget.getAttribute('data-youtube-title');

    const titleElement = this.modal.querySelector('.modal__title');

    if (titleElement) {
      titleElement.textContent = title;
    }

    this.player.load(youtubeId);
    this.player.play();

    this.toggleModal();
  }

  toggleModal() {
    this.modal.classList.toggle('flex');
    this.modal.classList.toggle('hidden');
    document.body.classList.toggle('overflow-hidden');

    // If open destroy vide player
    if (! document.body.classList.contains('overflow-hidden')) {
      if (this.player) {
        this.player.stop()
      }
    }
  }
}
